module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7xv50"))).then(() => parcelRequire('cvs7o'));